export const visit = (vm, at) => {
at({ "sv": { "conversations-visitor-experience-components": { "stagedAttachment": { "uploadProgress": "{{uploadedBytes}} av {{totalBytes}}" }, "fileSizeLimit": "Filen f\xE5r inte vara st\xF6rre \xE4n {{size}}", "screenCapture": "Sk\xE4rmdump" } } });
};